'use client';
import React from 'react';
import { OrderTotal as Shared } from '@launchstore/shared-puck';
import { useOrderData } from '@/lib/hooks/useOrderData';
import { convertToLocale } from '@lib/util/money';

const SharedRender = (Shared as any).render;

function OrderTotalImpl(props: any) {
  const { order, currencyCode } = useOrderData();
  if (!order) return <SharedRender {...props} />;
  const currency = order.currency_code ?? currencyCode ?? 'usd';
  const fmt = (amount: number) =>
    convertToLocale({ amount: Number(amount) || 0, currency_code: currency });
  return <SharedRender {...props} total={Number(order.total) || 0} formatPrice={fmt} />;
}

export const OrderTotal: any = { ...Shared, render: (props: any) => <OrderTotalImpl {...props} /> };
export default OrderTotal;
